let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f4DD6")).then(() => parcelRequire('6JHmj'));